import {
  ABOUT_CAT_PARTS,
  TERMS_LINKS,
  QUICK_ORDER,
  CONTACT_DEALER_LINK
} from 'constants/links';
import { getCatOrDealerLegalURL, getRelativeURLWithParams } from 'utils/url';
import { getSeoUrl, normalizeCommerceLink } from 'utils/links';
import { CATCORP_ESITE } from 'constants/common';

export const sortByName = (arr) => {
  const c = (a, b) => (a.name > b.name ? 1 : 0);
  return arr.toSorted((a, b) => (a.name < b.name ? -1 : c(a, b)));
};

export const getStaticMenu = ({
  t,
  dealerSeoURL,
  helpCenterUrl,
  helpCenterOldFaqLink,
  catalogId,
  storeId,
  langId,
  helpCenterEnabled,
  helpCenterContactSupportUrl,
  params,
  catLegalTermsFlagValue
}) => {
  const { CAT_PRIVACY_NOTICE_LINK, CAT_PRIVACY_NOTICE } = TERMS_LINKS;

  const isCatCorp = params.esite === CATCORP_ESITE;

  const showHelpCenter = isCatCorp || helpCenterEnabled;
  const helpCenterLink = showHelpCenter ? helpCenterUrl : helpCenterOldFaqLink;
  const getLink = (pathname: string) =>
    normalizeCommerceLink(getSeoUrl(params, pathname));
  const contactUsLink = showHelpCenter
    ? helpCenterContactSupportUrl
    : getLink(`${CONTACT_DEALER_LINK}?storeId=${storeId}`);
  const privacyNoticeURL = catLegalTermsFlagValue
    ? getCatOrDealerLegalURL(CAT_PRIVACY_NOTICE_LINK, params?.lang, true)
    : getCatOrDealerLegalURL(CAT_PRIVACY_NOTICE, params?.lang, true);

  return [
    {
      name: t('CUSTOMER_SERVICE'),
      subCategories: [
        {
          seoURL: normalizeCommerceLink(
            getRelativeURLWithParams(QUICK_ORDER, {
              catalogId,
              storeId,
              langId
            })
          ),
          name: t('Quick_Title')
        },
        {
          seoURL: `${helpCenterLink}`,
          name: t('FOOTER_HELP'),
          target: showHelpCenter ? '_blank' : '_self'
        },
        {
          seoURL: `${contactUsLink}`,
          name: t('Footer_CAT_ContactUs'),
          target: showHelpCenter ? '_blank' : '_self'
        }
      ]
    },
    {
      name: t('FOOTER_CORPORATE_INFO'),
      subCategories: [
        {
          seoURL: `${dealerSeoURL}${ABOUT_CAT_PARTS}`,
          name: t('FOOTER_ABOUT_US')
        },
        {
          seoURL: privacyNoticeURL,
          name: t('FOOTER_PRIVACY_POLICY')
        }
      ]
    }
  ];
};
